import './DropdownContent.scss';

import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const DropdownContent = ({ active, children }) => {
	return (
		<div className={cx('react__dd-cont', { active })} data-testid='dd-c'>
			{children}
		</div>
	);
};

DropdownContent.propTypes = {
	active: PropTypes.bool,
	children: PropTypes.node.isRequired
};

DropdownContent.defaultProps = {
	active: false
};

export default DropdownContent;
